<script setup>
import { inject, ref } from 'vue';
import Form from './Form.vue';

defineProps({
    as: {
        default: 'button',
    }
});

const formOpen = ref(false);
const dataView = inject('dataView');
</script>

<template>
    <component v-if="dataView.props.filters?.all?.length" :is="as" @click="formOpen = true">
        <slot></slot>

        <app-modal-bottom-sheet v-model:open="formOpen">
            <div class="p-4">
                <Form @done="formOpen = false" />
            </div>
        </app-modal-bottom-sheet>
    </component>
</template>
